<organization-top-navbar></organization-top-navbar>

<div class="block; relative isolate px-6 lg:px-8 mt-16">
  <div class="mx-auto max-w-5xl px-4 py-6">
    <div class="text-[#1B3777] text-center text-3xl lg:text-4xl DisplayHeading self-stretch font-bold">{{
      'DRIVE_IN_BOOKING.COMPLETE_DRIVE_IN' | transloco }}</div>
  </div>
</div>

<div class="container margin-auto">
  <form [formGroup]="driveInBookingForm">
    <div class="text-xl md:text-xl md:block w-97 font-small leading-none mt-4 text-center margin-bottom-14">{{
      'DRIVE_IN_BOOKING.ENTER_CAR_REG_NUMBER' | transloco }}</div>

    <div class="flex-center-relative">
      @if (isEditingRegNo) {
      <div class="width-425">
        <mat-form-field appearance="outline" class="form-field-full-width">
          <mat-label class="label-font-15">{{ 'DRIVE_IN_BOOKING.REG_NUMBER' | transloco }}</mat-label>
          <input (input)="regToUpper()" matInput [formControl]='driveInBookingForm.controls["registrationNumber"]'
            #regInput [minlength]="4" [maxlength]="9" class="input-large-3rem">
        </mat-form-field>
      </div>
      }
    </div>

    <div class="flex-center-relative">
      <div class="width-425">
        <div class="flex-space-between-mt-12">
          <button mat-raised-button color="warn" type="button" class="width-45" (click)="resetdriveInBookingForm()">{{
            'FORM.CLEAR' |
            transloco | uppercase}}</button>
          <button mat-raised-button color="primary" type="button" class="btn-success-45"
            [style.cursor]="(isLoading || driveInBookingForm.get('registrationNumber')?.value?.length < 2) ? 'not-allowed !important' : 'pointer'"
            [style.opacity]="(isLoading || driveInBookingForm.get('registrationNumber')?.value?.length < 2) ? '0.7 !important' : '1'"
            (click)="submitForm()"
            [disabled]="isLoading || driveInBookingForm.get('registrationNumber')?.value?.length < 2">
            @if (isLoading) {
            <mat-icon>
              <mat-spinner color="accent" diameter="20"></mat-spinner>
            </mat-icon>
            }
            @if (!isLoading) {
            <span>{{ 'DRIVE_IN_BOOKING.FIND_PARKING' | transloco }}</span>
            }
            @if (isLoading) {
            <span>{{ 'DRIVE_IN_BOOKING.SEARCHING' | transloco }}...</span>
            }
          </button>
        </div>
      </div>
    </div>
  </form>

  <!-- Parking To Be Created Message -->
  <!-- <div *ngIf="parkingToBeCreated" class="message-container info-message margin-top-35">
  <div class="message-content text-center">
    <h3 class="heading-2rem">{{ 'DRIVE_IN_BOOKING.WELCOME_TO_SKAVSTA' | transloco }}
    </h3>
    <p class="message-text-large">
      <strong>{{ 'DRIVE_IN_BOOKING.CREATE_PARKING_MSG_1' | transloco }}:</strong> {{
      'DRIVE_IN_BOOKING.CREATE_PARKING_MSG_2' | transloco }}<br><br>
      {{ 'DRIVE_IN_BOOKING.CREATE_PARKING_MSG_3' | transloco }}
    </p>
    <div class="action-buttons flex justify-center display-inline-block">
      <button mat-raised-button color="primary"
        class="text-sm sm:text-base md:text-lg px-3 sm:px-6 py-2 sm:py-3 md:py-4 lg:py-5 whitespace-nowrap"
        (click)="goToDriveInBookingForm()">{{ 'DRIVE_IN_BOOKING.COMPLETE_BOOKING' | transloco | uppercase
      }}</button>
    </div>
  </div>
</div> -->
</div>